import { motion } from "framer-motion";
import { ArrowRight, ArrowDown } from "lucide-react";
import { IMAGES, HERO_SPECIALTIES } from "../lib/data";

const fade = {
  hidden: { opacity: 0, y: 26 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: 0.12 * i, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Hero = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100svh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.heroMartini} alt="Espresso martini" className="w-full h-full object-cover object-right" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, #050505 6%, rgba(5,5,5,0.55) 52%, rgba(5,5,5,0.15) 100%)" }} />
      </div>

      <div className="relative z-10 mx-auto max-w-[1400px] w-full px-5 md:px-10 pt-28 pb-20 md:pb-24">
        <div className="max-w-3xl">
          <motion.p custom={0} variants={fade} initial="hidden" animate="show" className="text-[10px] md:text-xs uppercase tracking-[0.35em] md:tracking-[0.4em] text-[#D4AF37] mb-6 md:mb-8">
            Nationwide Premium Beverage Activations
          </motion.p>

          <motion.h1 custom={1} variants={fade} initial="hidden" animate="show" className="leading-[0.86]">
            <span className="block font-display font-black uppercase tracking-tight text-[#D4AF37] text-[clamp(2.8rem,11vw,9rem)]">
              Good Shot
            </span>
            <span className="block font-display font-medium uppercase text-white text-[clamp(0.85rem,3.4vw,2.6rem)] mt-2 md:mt-3" style={{ letterSpacing: "0.38em" }}>
              Espresso
            </span>
          </motion.h1>

          <motion.p custom={2} variants={fade} initial="hidden" animate="show" className="mt-6 md:mt-8 font-display text-base md:text-2xl uppercase tracking-[0.12em] md:tracking-[0.14em] text-white/90 font-semibold">
            One Good Shot Changes Everything.
          </motion.p>

          <motion.p custom={3} variants={fade} initial="hidden" animate="show" className="mt-5 md:mt-6 max-w-xl text-sm md:text-lg text-white/70 leading-relaxed font-light">
            We design, build and operate luxury beverage activations — serving hundreds to thousands of
            guests with speed, consistency and flawless presentation. Our signature Espresso Martini Bar,
            plus custom craft cocktail programs, executed at scale anywhere in the country.
          </motion.p>

          <motion.div custom={4} variants={fade} initial="hidden" animate="show" className="mt-6 md:mt-7 flex flex-wrap gap-2">
            {HERO_SPECIALTIES.map((s) => (
              <span key={s} className="text-[10px] md:text-[11px] uppercase tracking-[0.14em] text-white/60 border border-white/15 px-3 py-1.5 rounded-full">
                {s}
              </span>
            ))}
          </motion.div>

          <motion.div custom={5} variants={fade} initial="hidden" animate="show" className="mt-8 md:mt-10 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
            <button
              data-testid="hero-cta-inquire"
              onClick={() => go("#inquiry")}
              className="group inline-flex items-center justify-center gap-3 bg-[#D4AF37] text-black uppercase tracking-[0.16em] text-xs md:text-sm font-bold px-7 md:px-8 py-4 hover:bg-[#F3E5AB] transition-colors duration-300"
            >
              Bring Good Shot To Your Event
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            <button
              data-testid="hero-cta-services"
              onClick={() => go("#services")}
              className="inline-flex items-center justify-center gap-2 border border-white/20 text-white/85 uppercase tracking-[0.16em] text-xs md:text-sm hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300 px-7 py-4"
            >
              View Services
            </button>
          </motion.div>
        </div>
      </div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.4, duration: 1 }} className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden sm:flex flex-col items-center gap-2 text-white/40">
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <ArrowDown className="w-4 h-4 animate-bounce" />
      </motion.div>
    </section>
  );
};
